import axios from "axios";

declare const window: any;

const STORAGE_KEYS = {
  intro: "cached_intro",
  client: "cached_client",
  lastUpdate: "last_update_available",
};

const formatDate = () => {
  const now = new Date();

  let formatted = now.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return formatted.replace("AM", "a.m.").replace("PM", "p.m.");
};

const saveCache = (key: string, value: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error("Error guardando cache", err);
  }
};

const loadCache = (key: string) => {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (err) {
    console.error("Error cargando cache", err);
    return null;
  }
};

export const intro = async () => {
  if (window.hybrid) {
    try {
      const response = await axios.post(
        "https://service-cloud-admin-container.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/client/intro",
        //"http://localhost:5050/api/client/intro",
        { project: window.project_id || "CP50" }
      );

      const formattedData = { data: response.data };

      window.intro = formattedData;
      window.last_update_available = formatDate();

      saveCache(STORAGE_KEYS.intro, formattedData);
      saveCache(STORAGE_KEYS.lastUpdate, window.last_update_available);

      return window.intro;
    } catch (error) {
      console.warn("No hay internet, cargando cache intro");

      const cached = loadCache(STORAGE_KEYS.intro);
      const cachedDate = loadCache(STORAGE_KEYS.lastUpdate);

      if (cached) window.intro = cached;
      if (cachedDate) window.last_update_available = cachedDate;

      return window.intro;
    }
  } else {
    // Web → siempre consumir API
    const response = await axios.post(
      "https://service-cloud-admin-container.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/client/intro",
      //"http://localhost:5050/api/client",
      { project: window.project_id || "CP50" }
    );
    return { data: response.data };
  }
};

export const all = async () => {
  if (window.hybrid) {
    try {
      const response = await axios.post(
        "https://service-cloud-admin-container.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/client",
        //"http://localhost:5050/api/client",
        { project: window.project_id || "CP50" }
      );

      const formattedData = { data: response.data };

      window.client = formattedData;
      window.last_update_available = formatDate();

      saveCache(STORAGE_KEYS.client, formattedData);
      saveCache(STORAGE_KEYS.lastUpdate, window.last_update_available);

      return window.client;
    } catch (error) {
      console.warn("No hay internet, cargando cache client");

      const cached = loadCache(STORAGE_KEYS.client);
      const cachedDate = loadCache(STORAGE_KEYS.lastUpdate);

      if (cached) window.client = cached;
      if (cachedDate) window.last_update_available = cachedDate;

      return window.client;
    }
  } else {
    const response = await axios.post(
      "https://service-cloud-admin-container.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/client",
      //"http://localhost:5050/api/client",
      { project: window.project_id || "CP50" }
    );
    return { data: response.data };
  }
};
